import EntityConstants from "../configs/EntityConstants";
import { emailRegex } from "../configs/App.Regex";
import { GET } from "./CRUDService";

export const normalizeEmail = (email) =>
  typeof email === "string" ? email.trim().toLowerCase() : "";

export const isValidEmailFormat = (email) => {
  if (!email || typeof email !== "string") {
    return false;
  }
  return emailRegex.test(email.trim());
};

export const isRecaptchaRequiredFromPermissions = (data) =>
  data?.recaptcha_required !== false;

export const isPostIssuanceVerificationEnabledFromPermissions = (permissions) =>
  permissions?.is_blockchain_verification_enabled === true ||
  permissions?.is_post_issuance_verification_enabled === true;

export const fetchRecaptchaRequirement = async (email, { signal } = {}) => {
  const trimmed = email?.trim();
  if (!trimmed) {
    return true;
  }

  try {
    const response = await GET(
      `${EntityConstants.CURRENT_USER_PERMISSIONS}?email=${encodeURIComponent(trimmed)}`,
      { signal },
    );

    if (!response?.ok) {
      return true;
    }

    let data;
    try {
      data = await response.json();
    } catch {
      return true;
    }

    return isRecaptchaRequiredFromPermissions(data);
  } catch (error) {
    if (error?.name === "AbortError") {
      throw error;
    }
    return true;
  }
};
